<form (ngSubmit)="onSearchSubmit()" class="search-form">
  <div class="autocomplete-wrapper">
    <rds-form-field labelPosition="none">
      <input
        class="search-input"
        rdsInput
        type="text"
        [placeholder]="placeholder()"
        [ngModel]="searchQuery()"
        (ngModelChange)="onSearchInputChange($event)"
        (focus)="onInputFocus()"
        (blur)="onInputBlur()"
        name="searchQuery"
        autocomplete="off"
        [disabled]="!isSearchEnabled()"
      />
    </rds-form-field>

    @if (showAutocomplete() && showSuggestions() && suggestions().length > 0) {
      <div class="suggestions-dropdown">
        @for (suggestion of suggestions(); track suggestion) {
          <div
            class="suggestion-item"
            (click)="onSuggestionClick(suggestion)"
            [innerHTML]="highlightMatch(suggestion)"
          ></div>
        }
      </div>
    }
  </div>

  <button
    type="submit"
    rds-primary-button
    size="l"
    faroAction="site search"
    [attr.aria-label]="buttonText()"
    [disabled]="!isSearchEnabled()"
  >
    <!-- Optional leading glyph (the assistant surfaces project a sparkle).
         Projecting nothing leaves the button exactly as it was. -->
    <ng-content select="[searchButtonIcon]" />
    {{ buttonText() }}
  </button>
</form>
